import { render } from "./MImageFileInput.vue?vue&type=template&id=2a76782a"
import script from "./MImageFileInput.vue?vue&type=script&lang=ts"
export * from "./MImageFileInput.vue?vue&type=script&lang=ts"
script.render = render

export default script